import { forwardRef, type Ref, type SVGProps } from "react";
function SvgDevices(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.122 19h1.951m-15.61-2V6c0-1.657 1.31-3 2.927-3h10.732c1.616 0 2.927 1.343 2.927 3v2M3.463 17H2c0 1.657 1.31 3 2.927 3h9.756m-11.22-3h10.732m2.927 4h1.951C20.69 21 22 19.657 22 18v-7c0-1.657-1.31-3-2.927-3h-1.951c-1.617 0-2.927 1.343-2.927 3v7c0 1.657 1.31 3 2.927 3"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDevices);
export default ForwardRef;
